import React from 'react';
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';

import {
  faTimes,
  faDownload,
  faPaperclip,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './styles.css';

const FilesFieldListItem = props => {
  const { value, isValid, index, onRemove, onDownload, isUploaded } = props;

  const handleRemove = () => {
    onRemove &&
      typeof onRemove === 'function' &&
      onRemove(index, isUploaded ? value.id : null);
  };

  const handleDownload = () => {
    onDownload && typeof onDownload === 'function' && onDownload(value.id);
  };

  return (
    <div className="files-field-list-item">
      <div className="files-field-list-item__fields">
        <MediaQuery query="(min-width: 1001px)">
          <div className="files-field-list-item__field files-field-list-item__field--status">
            <div className="files-field-list-item__value">
              {isUploaded ? (
                <FontAwesomeIcon
                  icon={faPaperclip}
                  size="lg"
                  className="files-field-list-item__icon files-field-list-item__icon--uploaded"
                />
              ) : (
                <FontAwesomeIcon
                  icon={faPaperclip}
                  size="lg"
                  className="files-field-list-item__icon"
                />
              )}
            </div>
          </div>

          <div className="files-field-list-item__field files-field-list-item__field--fluid">
            <div className="files-field-list-item__block">
              <div className="files-field-list-item__name">File Name</div>
              <div
                className={
                  isValid
                    ? 'files-field-list-item__value'
                    : 'files-field-list-item__value files-field-list-item__value--invalid'
                }
              >
                {value.file.name}
              </div>
            </div>
          </div>

          <div className="files-field-list-item__field files-field-list-item__field--size">
            <div className="files-field-list-item__block">
              <div className="files-field-list-item__name">File Size</div>
              <div className="files-field-list-item__value">
                {(value.file.size / 1024).toFixed(1)}KB
              </div>
            </div>
          </div>

          {onDownload && (
            <div className="files-field-list-item__field files-field-list-item__field--status">
              <div className="files-field-list-item__value">
                {isUploaded && (
                  <FontAwesomeIcon
                    onClick={value.file.disabled ? null : handleDownload}
                    icon={faDownload}
                    size="lg"
                    className="files-field-list-item__icon files-field-list-item__icon--download"
                  />
                )}
              </div>
            </div>
          )}

          <div className="files-field-list-item__field files-field-list-item__field--remove">
            <div className="files-field-list-item__value">
              <FontAwesomeIcon
                onClick={value.file.disabled ? null : handleRemove}
                icon={faTimes}
                color={value.file.disabled ? '#ccc' : '#f40'}
                size="lg"
                className={
                  value.file.disabled
                    ? 'files-field-list-item__remove-btn files-field-list-item__remove-btn--disabled'
                    : 'files-field-list-item__remove-btn'
                }
              />
            </div>
          </div>
        </MediaQuery>

        <MediaQuery query="(max-width: 999px)">
          <div className="files-field-list-item__field files-field-list-item__field--status">
            <div className="files-field-list-item__value">
              {isUploaded ? (
                <FontAwesomeIcon
                  icon={faPaperclip}
                  size="lg"
                  className="files-field-list-item__icon files-field-list-item__icon--uploaded"
                />
              ) : (
                <FontAwesomeIcon
                  icon={faPaperclip}
                  size="lg"
                  className="files-field-list-item__icon"
                />
              )}
            </div>
            <div className="files-field-list-item__block files-field-list-item__block--static">
              <div className="files-field-list-item__value">
                {(value.file.size / 1024).toFixed(1)}KB
              </div>
            </div>
          </div>

          <div className="files-field-list-item__field files-field-list-item__field--fluid">
            <div className="files-field-list-item__block">
              <div className="files-field-list-item__name">File Name</div>
              <div
                className={
                  isValid
                    ? 'files-field-list-item__value'
                    : 'files-field-list-item__value files-field-list-item__value--invalid'
                }
              >
                {value.file.name}
              </div>
            </div>
          </div>
          <div className="files-field-list-item__field files-field-list-item__field--remove">
            <div className="files-field-list-item__value">
              <FontAwesomeIcon
                onClick={value.file.disabled ? null : handleRemove}
                icon={faTimes}
                color={value.file.disabled ? '#ccc' : '#f40'}
                size="lg"
                className={
                  value.file.disabled
                    ? 'files-field-list-item__remove-btn files-field-list-item__remove-btn--disabled'
                    : 'files-field-list-item__remove-btn'
                }
              />
            </div>
          </div>
        </MediaQuery>
      </div>
    </div>
  );
};

FilesFieldListItem.propTypes = {
  value: PropTypes.shape({
    file: PropTypes.object.isRequired,
    description: PropTypes.string,
  }),
  isValid: PropTypes.bool,
  isUploaded: PropTypes.bool,
  index: PropTypes.number,
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  onDownload: PropTypes.func,
  helper: PropTypes.func,
};

export default FilesFieldListItem;
